import { QueryClient } from '@tanstack/react-query';
import { cacheKey, FEATURE_FLAG_NAMES } from '@tn/foundation/entities/feature-flags/constants';
import { getFeatureFlag } from '@tn/foundation/entities/feature-flags/utils/getFeatureFlag';

import { FeatureFlags } from '../../graphql/constants';

export const getFeatureFlagGuards = (queryClient: QueryClient) => {
    const getFeatureFlags = () =>
        queryClient.getQueryData<{ featureFlags?: Record<string, boolean> }>([cacheKey])
            ?.featureFlags ?? {};

    return {
        tnSignInDefaultEnabled: () =>
            Boolean(getFeatureFlag(getFeatureFlags())(FeatureFlags.TN_SIGNIN_DEFAULT_ENABLED)),
        unifiedIdentityPlatformEnabled: () =>
            Boolean(
                getFeatureFlag(getFeatureFlags())(FEATURE_FLAG_NAMES.UNIFIED_IDENTITY_PLATFORM),
            ),
    };
};
